import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Loading from '../../components/LoadingBit';

import ScrollableView from '../../components/ScrollableView';
import { useInterval } from '../../utils/useInterval';

import {
  backgroundCss,
  wrapperCss,
  messageCss,
} from './PaymentLinkPage.styles';

const PaymentLinkLoadingScreen = ({ onRefresh }) => {
  const { t } = useTranslation();

  useInterval(onRefresh, 10000);

  return (
    <div css={backgroundCss}>
      <ScrollableView>
        <div css={wrapperCss}>
          <Loading
            show
            center
            loadingColor="#FFFFFF"
            style={{ height: 'auto', flexGrow: 0, margin: 20 }}
          />
          <div css={messageCss}>{t('paymentLink:processingTransaction')}</div>
        </div>
      </ScrollableView>
    </div>
  );
};

PaymentLinkLoadingScreen.propTypes = {
  onRefresh: PropTypes.func.isRequired,
};

export default PaymentLinkLoadingScreen;
